var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dae706df21b4371d1d284363abc13a32a491fefb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cloud-frontend@materializeinc"]={id:"dae706df21b4371d1d284363abc13a32a491fefb"};
      